"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExchangeAddress = exports.isValidHost = exports.isValidEmail = exports.isValidPort = exports.isGreaterThanZero = exports.getInboxErrorMessage = exports.getHandledInboxErrorMessage = exports.getCalDAVErrorData = exports.getServerValidationMessages = void 0;

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _Domain = _interopRequireDefault(require("PatternValidationJS/patterns/Domain"));

var _CalDavErrors = require("InboxConnectUtils/constants/CalDavErrors");

var _InboxErrors = require("../constants/InboxErrors");

var _StringValidation = require("./StringValidation");

var GENERIC = _CalDavErrors.CALDAV_ERROR_TYPES.GENERIC,
    NOT_FOUND = _CalDavErrors.CALDAV_ERROR_TYPES.NOT_FOUND,
    UNAUTHORIZED = _CalDavErrors.CALDAV_ERROR_TYPES.UNAUTHORIZED;

var getServerValidationMessages = function getServerValidationMessages(serverValidationErrors) {
  return {
    email: serverValidationErrors.get('APP_PASSWORD_REQUIRED') || serverValidationErrors.get('UNAUTHORIZED'),
    password: serverValidationErrors.get('UNAUTHORIZED'),
    imapHost: serverValidationErrors.get('IMAP_AUTHENTICATION_ERROR') || serverValidationErrors.get('IMAP_SETTINGS_INCORRECT') || serverValidationErrors.get('IMAP_VALIDATE_ERROR') || serverValidationErrors.get('GENERIC_IMAP_DISABLED'),
    imapPort: serverValidationErrors.get('IMAP_AUTHENTICATION_ERROR') || serverValidationErrors.get('IMAP_SETTINGS_INCORRECT') || serverValidationErrors.get('IMAP_VALIDATE_ERROR') || serverValidationErrors.get('GENERIC_IMAP_DISABLED'),
    smtpHost: serverValidationErrors.get('SMTP_SETTINGS_INCORRECT'),
    smtpPort: serverValidationErrors.get('SMTP_SETTINGS_INCORRECT'),
    acceptUntrustedCert: serverValidationErrors.get('UNTRUSTED_CERTIFICATES')
  };
};

exports.getServerValidationMessages = getServerValidationMessages;

var getCalDAVErrorData = function getCalDAVErrorData(_ref) {
  var status = _ref.status,
      responseText = _ref.responseText;

  switch (status) {
    case 400:
      if (responseText.includes('Invalid calendar uri')) {
        return _CalDavErrors.CALDAV_ERROR_MAP[NOT_FOUND];
      }

      return _CalDavErrors.CALDAV_ERROR_MAP[GENERIC];

    case 403:
      return _CalDavErrors.CALDAV_ERROR_MAP[UNAUTHORIZED];

    case 404:
      return _CalDavErrors.CALDAV_ERROR_MAP[NOT_FOUND];

    case 500:
      if (responseText.includes('Failed to load credentials for UserInfo')) {
        return _CalDavErrors.CALDAV_ERROR_MAP[UNAUTHORIZED];
      }

      return _CalDavErrors.CALDAV_ERROR_MAP[GENERIC];

    default:
      return _CalDavErrors.CALDAV_ERROR_MAP[GENERIC];
  }
};
/**
 * Get translation keys for known errors.
 *
 * **Note**: Intended for internal library use only.
 *
 * @param {string} status Status/error code to look up for translation
 * @returns {?{ description: string, options: object }} Translated data or null
 */


exports.getCalDAVErrorData = getCalDAVErrorData;

var getHandledInboxErrorMessage = function getHandledInboxErrorMessage(status) {
  return (0, _InboxErrors.parseSharedInboxErrorMessage)(status) || _InboxErrors.INBOX_ERROR_MESSAGES[status] || null;
};
/**
 * Get get translation keys for error. Returns fallback translation if not explicitly handled.
 *
 * @param {string} status Status/error code to look up for translation
 * @returns {{ key: string, options: object }} Translation data for I18n components.
 */


exports.getHandledInboxErrorMessage = getHandledInboxErrorMessage;

var getInboxErrorMessage = function getInboxErrorMessage(status) {
  var errString = getHandledInboxErrorMessage(status) || _InboxErrors.INBOX_ERROR_MESSAGES.error;

  return {
    key: errString.description,
    options: errString.options
  };
};

exports.getInboxErrorMessage = getInboxErrorMessage;

var isGreaterThanZero = function isGreaterThanZero(value) {
  return !!value && typeof value === 'number' && value > 0;
}; // Only doing localhost for now - could expand to internal IPs later if worth it


exports.isGreaterThanZero = isGreaterThanZero;

var isUnroutableIP = function isUnroutableIP(ipAddress) {
  return ipAddress === '127.0.0.1';
};

var isValidPort = function isValidPort(value) {
  return isGreaterThanZero(value) || (0, _StringValidation.isNonEmptyString)(value);
};

exports.isValidPort = isValidPort;

var isValidEmail = function isValidEmail(email) {
  return email && _EmailAddress.default.test(email);
};

exports.isValidEmail = isValidEmail;

var isValidHost = function isValidHost(host) {
  return host && _Domain.default.test(host) && !isUnroutableIP(host);
};
/**
 * Given a raw url, this does some very basic validation for Exchange address check.
 * This should be used for hinting to the user - not necessarily a blocker to submission.
 * @internal
 * @param {string} value Raw URL user input
 * @returns {boolean} Validation status
 */


exports.isValidHost = isValidHost;

var isExchangeAddress = function isExchangeAddress(value) {
  return !!value && /^https:\/\/.+\.asmx$/.test(value);
};

exports.isExchangeAddress = isExchangeAddress;